import { render, staticRenderFns } from "./RecommendationSliders.vue?vue&type=template&id=a89af7cc&scoped=true"
import script from "./RecommendationSliders.vue?vue&type=script&lang=js"
export * from "./RecommendationSliders.vue?vue&type=script&lang=js"
import style0 from "./RecommendationSliders.vue?vue&type=style&index=0&id=a89af7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89af7cc",
  null
  
)

export default component.exports